import React, { FC, ReactElement } from "react";
import Modal from 'react-modal';
import WizardSideBarStep from "../../models/WizardSideBarStep";
import Wizard from "../wizard/wizard";
import { Formik, Form } from "formik";

interface EditWidgetModalProps {
    isOpen: boolean;
    onClose: () => void;
    steps: WizardSideBarStep[];
    content: ReactElement[];
    title: string;
    step?: number;
    widget: any;
    onSave: (values: any) => void;
}

const EditWidgetModal: FC<EditWidgetModalProps> = ({ isOpen, onClose, steps, content, title, step = 0, widget, onSave }) => {
    return <Modal
        isOpen={isOpen}
        ariaHideApp={false}
        overlayClassName="flex w-screen position-float-modal fixed top-0 left-0 h-screen bg-opacity-75 bg-white"
        className="bg-white border-none m-auto shadow select-none outline-none w-content">
        <Formik
            enableReinitialize={true}
            initialValues={widget}
            onSubmit={onSave}>
            <Form>
                <Wizard
                    name={title}
                    step={step}
                    onClose={onClose}
                    sidebarSteps={steps}>
                    {content}
                </Wizard>
            </Form>
        </Formik>
    </Modal>
}

export default EditWidgetModal;